export const DEFAULT_MODAL_WIDTH = 1000
export const SMALL_MODAL_WIDTH = 700

export const NIGHTLY_ICURE_CLOUD_URL = 'https://nightly.icure.cloud'
export const MSG_GW_URL = 'https://msg-gw.icure.cloud'
// export const MSG_GW_URL = 'https://gwad.taktik.to'
export const SPEC_ID = import.meta.env.VITE_EXTERNAL_SERVICES_SPEC_ID
export const PROCESS_ID = import.meta.env.VITE_EMAIL_AUTHENTICATION_PROCESS_ID
export const PROJECT_ID = import.meta.env.VITE_PROJECT_ID

export const CUSTOM_TAG_TYPE = 'PETRA_CARE'
